import styled from 'styled-components';
import { Divider } from 'antd';
import { SectionLastHeading } from "../../../../../../../../CommonComponents/commonStyles";

export const ContribType = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.greyishBrown};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`;

export const ContributionName = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.textColor};
margin-right: 5px;
word-break: break-all;
padding-bottom:${props => props.paddingBottom};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`;

export const TransactionId = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size:  ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.headingColor};
margin-left: 10px;
word-break: break-all;
padding-bottom:${props => props.paddingBottom};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.secondary};
}
`;

export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-bottom: 20px;
     margin-top:20px;
}
`;

export const ComponentDividerLast = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-bottom: 40px;
     margin-top: 40px;
}
`;

export const SectionHeading = styled(SectionLastHeading)`
margin-bottom: 20px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h4};

}
`;
